exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "header.ui.segment:before{height:70px;display:block;content:\"\"}.iconFlood.ui.mini.images{text-align:center}.iconFlood.ui.mini.images>img{max-width:18px;margin:2px}div.best-movie{width:100%!important;max-height:none!important}.no-padding{padding:0!important}.narrow{margin-top:-30px!important}@media screen and (min-width:599px){p.small{font-size:.9em}}.ui.items>.item>.image>img{margin-left:auto;margin-right:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/styles/App.css
// module id = 92
// module chunks = 0